import { getInitials } from "@/lib/string";

interface PatientAvatarProps {
  fullName: string;
}

export function PatientAvatar({ fullName }: PatientAvatarProps) {
  return (
    <div className="flex size-8 shrink-0 items-center justify-center rounded-[10px] bg-[linear-gradient(135deg,#1884F9,#619BFF)]">
      <span className="text-[11px] font-bold tracking-[0.02em] text-white">
        {getInitials(fullName)}
      </span>
    </div>
  );
}
